module.exports = __webpack_public_path__ + "static/media/download-on-the-app-store.6cb12e90.svg";